import { ApiError, useAppStatus } from "@wexinc/wex-common-web";
import { LoadableContentContainer } from "@wexinc/wex-ui";
import { useEffect, useState } from "react";
import { useErrorBoundary } from "react-error-boundary";
import { LoginMethods, useCopSecurityService } from "services/security";
import useInvitationService from "services/security/useInvitationService";
import IdpPicker from "../components/IdpPicker";
import useSecurityNavigation from "../useSecurityNavigation";

const InvitationsLanding: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const { showBoundary } = useErrorBoundary();
  const invitationService = useInvitationService();
  const copSecurityService = useCopSecurityService();
  const [showIdpPicker, setShowIdpPicker] = useState<{
    display: boolean;
    loginMethods?: LoginMethods;
    invitationId?: number;
    email?: string;
    invitationToken?: string;
  }>({ display: false });
  const loginNavigation = useSecurityNavigation();
  const appStatus = useAppStatus();

  useEffect(() => {
    async function onLoad() {
      const invitationId = invitationService.getInvitationId();
      const securityToken = copSecurityService.getSecurityTokenFromUrl();

      if (invitationId && securityToken) {
        try {
          const loginMethods = await invitationService.getInvitationLoginMethods(invitationId, securityToken);

          if (
            !loginMethods ||
            (!loginMethods.usernameAndPasswordEnabled && (loginMethods.identityProviders || []).length === 0)
          ) {
            appStatus.setGlobalMessage("Cannot log in.");
          }

          setLoading(false);

          if (loginMethods.usernameAndPasswordEnabled && loginMethods.identityProviders.length === 0) {
            loginNavigation.navigateToLoginRegistration(loginMethods.email, invitationId, securityToken);
          } else if (loginMethods.usernameAndPasswordEnabled === false && loginMethods.identityProviders.length === 1) {
            loginNavigation.navigateToIdpLogin(
              loginMethods.email,
              loginMethods.identityProviders[0].id,
              undefined,
              loginNavigation.getInvitationRegistrationPath(loginMethods.email, invitationId, securityToken),
            );
          } else {
            setShowIdpPicker({
              display: true,
              loginMethods,
              invitationId,
              email: loginMethods.email,
              invitationToken: securityToken,
            });
          }
        } catch (error) {
          if (error instanceof ApiError) {
            if (error.code === 404 || error.code === 403) {
              appStatus.setGlobalMessage(error.message);
            } else {
              showBoundary(error);
            }
          } else {
            showBoundary(Error("Unexpeced error."));
          }
        }
      } else {
        appStatus.setGlobalMessage("No invitation.");
      }
    }

    // Annoying to have to do, but in the authorized area of the app, securityService takes care of this.
    appStatus.setAppStatusAction("reset");
    onLoad();
  }, []);
  return (
    <>
      <LoadableContentContainer
        showLoading={loading}
        message="Loading..."
      />
      {showIdpPicker.display && (
        <IdpPicker
          invitationIdIfInvitationFlow={showIdpPicker.invitationId!}
          email={showIdpPicker.email!}
          loginMethods={showIdpPicker.loginMethods!}
          invitationTokenIfInvitationFlow={showIdpPicker.invitationToken}
        />
      )}
    </>
  );
};

export default InvitationsLanding;
